<ng-container *ngIf="ready">
  <div class="bg-white height500px overflowAuto scrollbar-secondary-alternative">
    <form onkeypress="return event.keyCode != 13;">
      <div class="mainBody mt-3">
        <strong *ngIf="conceptContact.uid == null">Nueva Tarifa</strong>
        <strong *ngIf="conceptContact.uid != null">Editar Tarifa</strong>
        <hr>

        <div class="flex-container">
          <div class="two-column">
            <div class="flex-container w-100">
              <div class="two-column">
                <app-select name="conceptContact.contactUid" [(ngModel)]="conceptContact.contactUid"
                  [ngModelOptions]="{standalone: true}"
                  [config]="{ label: 'Cliente', placeholder: 'Seleccionar', options: contactsOptions }">
                </app-select>
              </div>
              <div class="two-column">
                <app-select name="conceptContact.conceptUid" [(ngModel)]="conceptContact.conceptUid"
                  [ngModelOptions]="{standalone: true}"
                  [config]="{ label: 'Concepto', placeholder: 'Seleccionar', options: conceptsOptions }">
                </app-select>
              </div>
            </div>
          </div>
          <div class="two-column">
            <div class="flex-container w-100">
              <div class="two-column">
                <app-input inputType="text" placeholder="Código Concepto" name="conceptContact.conceptCode"
                  [(ngModel)]="conceptContact.conceptCode" [ngModelOptions]="{standalone: true}"></app-input>
              </div>

              <div class="two-column">
                <mat-form-field class="w-100">
                  <input type="text" matInput placeholder="Precio Neto" name="conceptContact.price" required
                    [(ngModel)]="conceptContact.price" [ngModelOptions]="{standalone: true}" numberDecimalsDirective>
                </mat-form-field>
              </div>

            </div>
          </div>
        </div>
        <div class="flex-container w-100 mt-3 mb-3">
          <div class="two-column">
            <div class="d-flex justify-content-center flex-column flex-md-row">
              <button mat-stroked-button (click)="onSubmit()" class="me-0 me-md-2 mb-2 mb-md-0">
                <mat-icon>save</mat-icon>
                Guardar
              </button>
              <button mat-stroked-button (click)="closeDialog()">
                <mat-icon>close</mat-icon>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>
<ng-container *ngIf="ready === false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>